import * as React from 'react';
//import DisplayHTML from '../../../components/DisplayHTML/DisplayHTML';
import { Stack } from '@mui/material';
import { shallowEqual } from 'react-redux';
import { useEmail } from '../../../sic-lib/api/hooks/useEmail';
import { Contact } from '../../../sic-lib/types/Contact';
import { setEmailThreadDrawer } from '../../../store/contact';
import { useAppDispatch, useAppSelector } from '../../../store/hooks';
import AxiosErrorAlert from '../../Shared/Alerts/AxiosErrorAlert';
import { DrawerCommon } from '../../Shared/Drawer/DrawerCommon';
import Loader from '../../Shared/Loader';
import EmailThreadBody from './EmailThreadBody';
import EmailThreadReply from './EmailThreadReply';

interface Props {
    contact: Contact;
}

export default function EmailThreadModal({ contact }: Props) {
    const dispatch = useAppDispatch();

    const store = useAppSelector(state => {
        return {
            channelItem: state.contact?.emailThreadDrawer,
        };
    }, shallowEqual);

    const [reply, setReply] = React.useState<boolean>(false);

    const {
        data: emailData,
        isLoading: isEmailLoading,
        isSuccess: isEmailSuccess,
        isError: isEmailError,
        error: emailError,
    } = useEmail(store.channelItem?.contactId!, store.channelItem?.channelId!);

    const handleClose = () => {
        dispatch(setEmailThreadDrawer({ channelItem: undefined }));
    };

    const handleReply = () => {
        setReply(!reply);
    };

    return (
        <DrawerCommon
            open={!!store.channelItem}
            handleOnClose={handleClose}
            title="View Email Thread"
            width="1200px"
            footer={
                <>
                    {reply && !!emailData && (
                        <EmailThreadReply contact={contact} subject={emailData?.subject} />
                    )}
                </>
            }
        >
            <Stack p={2} spacing={2}>
                {((!emailData && !isEmailLoading) || isEmailError) && (
                    <AxiosErrorAlert
                        error={emailError || 'Sorry, we could not load this email. Try again later'}
                        severity="error"
                    />
                )}
                <Loader isLoading={isEmailLoading}>
                    {emailData && (
                        <EmailThreadBody
                            emailData={emailData}
                            onReplay={handleReply}
                            isReplyOpen={reply}
                        />
                    )}
                </Loader>
            </Stack>
        </DrawerCommon>
    );
}
